import { useTraceDataStore } from '@/stores/traceDataStore'
import { useEventBus } from '@/utils/events'
import { useCellSelection } from './cell-selection'

export function useRegisterHighlighting() {
  const { highlightElement } = useCellSelection()

  const traceDataStore = useTraceDataStore()

  useEventBus('highlightAllDirectLinksOnSelectionSwitch', toggleHighlightAllDirectLinksOnSelection)

  function toggleHighlightAllDirectLinksOnSelection(elementView: joint.dia.ElementView): void {
    traceDataStore.toggleHighlightAllDirectLinksOnSelection()

    highlightElement(elementView)
  }
}
